import React from 'react';
import { ChipProps } from '@material-ui/core/Chip';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';

const MuiChip: ChipProps = {
    deleteIcon: <CloseOutlinedIcon />,
};

export default MuiChip;
